import { render, staticRenderFns } from "./safOpinionBoardManage.vue?vue&type=template&id=c74eaba0"
import script from "./safOpinionBoardManage.vue?vue&type=script&lang=js"
export * from "./safOpinionBoardManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c74eaba0')) {
      api.createRecord('c74eaba0', component.options)
    } else {
      api.reload('c74eaba0', component.options)
    }
    module.hot.accept("./safOpinionBoardManage.vue?vue&type=template&id=c74eaba0", function () {
      api.rerender('c74eaba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sob/safOpinionBoardManage.vue"
export default component.exports